import { useTranslation } from 'react-i18next';

interface Feature {
  icon: string;
  titleKey: string;
  descKey: string;
}

const features: Feature[] = [
  { icon: 'ri-shield-check-line', titleKey: 'features.security.title', descKey: 'features.security.desc' },
  { icon: 'ri-server-line', titleKey: 'features.stable.title', descKey: 'features.stable.desc' },
  { icon: 'ri-flashlight-line', titleKey: 'features.speed.title', descKey: 'features.speed.desc' },
  { icon: 'ri-customer-service-2-line', titleKey: 'features.service.title', descKey: 'features.service.desc' },
  { icon: 'ri-lock-line', titleKey: 'features.data.title', descKey: 'features.data.desc' },
  { icon: 'ri-emotion-happy-line', titleKey: 'features.experience.title', descKey: 'features.experience.desc' },
];

export default function FeatureSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {t('features.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-7 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-lg`} />
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {t(feature.titleKey)}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {t(feature.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}